import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-718617b2")

_pushScopeId("data-v-718617b2")
const _hoisted_1 = { class: "timeout-alert" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ログインの有効期限が切れました。もう一度ログインしてください。 ")
const _hoisted_3 = { class: "button-frame" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("ログイン画面へ戻る ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          _createVNode(_component_vue_content_item_frame, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_fa_icon, { icon: "exclamation-circle" }),
                _hoisted_2
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_normal_button, {
          type: "normal",
          class: "login-button",
          state: "normal",
          onClick: _ctx.onLogout
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
})